export default function ripple(event) {
  const targetElement = event.currentTarget;

  // to avoid problems where positioning or overflow is an issue,
  // create an invisible overlay span to contain the ripple
  const rippleContainer = document.createElement('span');
  rippleContainer.classList.add('ripple-container');
  rippleContainer.style.height = targetElement.clientHeight + 'px';
  rippleContainer.style.width = targetElement.clientWidth + 'px';

  const circle = document.createElement('span');
  circle.classList.add('ripple');

  const diameter = Math.max(targetElement.clientWidth, targetElement.clientHeight);
  const radius = diameter / 2;

  const diameterUnits = `${diameter}px`
  circle.style.width = diameterUnits;
  circle.style.height = diameterUnits;
  // center the ripple at the touch-point/click-point
  circle.style.top = `${event.offsetY - radius}px`;
  circle.style.left = `${event.offsetX - radius}px`;
  // remove ripple at the end of animation
  circle.addEventListener('animationend', () => {
    if (circle.parentElement.classList.contains('ripple-container')) {
      circle.parentElement.remove();
    } else {
      circle?.remove();
    }
    if (targetElement?.classList.contains('ripple-active')) {
      targetElement?.classList.remove('ripple-active');
    }
  });

  targetElement?.classList.add('ripple-active');

  // add timeout so ripple elements don't interfere with button/link behavior;
  setTimeout(() => {
    if (targetElement?.tagName?.toUpperCase() === 'INPUT') {
      // input elements can't have elements appended to them,
      // so append the container to its parent
      targetElement?.parentElement?.appendChild(rippleContainer);
    } else {
      // for other elements, append the container to the target element
      targetElement?.appendChild(rippleContainer);
    }
  }, 100);
  // then append the circle to its container
  rippleContainer.appendChild(circle);
}
